export default __webpack_public_path__ + "static/media/arrow_white.5bb21c02.svg";